import * as yup from 'yup';

export const UpdateShowDeltaTResponseSchema = yup.object({
  exit_status: yup.number().defined(),
  show_delta_t: yup.boolean().defined(),
});

export type UpdateShowDeltaTResponse = yup.InferType<
  typeof UpdateShowDeltaTResponseSchema
>;
